var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "",
    stroke: "none",
    fill: "#802ce4",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 183.288 133.836 L 117.077 172.500 117.059 250 L 117.041 327.500 182.445 365.725 C 218.417 386.748, 248.324 404.073, 248.905 404.225 C 249.486 404.376, 279.657 387.175, 315.951 366 L 381.939 327.500 381.955 250 L 381.970 172.500 321.307 137 C 287.943 117.475, 258.137 100.076, 255.072 98.336 L 249.500 95.172 183.288 133.836 M 240.764 205.518 L 210.028 236.536 225.493 252.018 L 240.957 267.500 234.470 295.475 C 230.903 310.862, 228.106 323.818, 228.256 324.267 C 228.405 324.716, 242.098 311.189, 258.684 294.208 L 288.841 263.333 273.514 247.917 L 258.186 232.500 264.995 203.500 C 268.740 187.550, 271.735 174.500, 271.652 174.500 C 271.568 174.500, 257.669 188.458, 240.764 205.518",
    stroke: "none",
    fill: "#7c2ce4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlLogo);
export default __webpack_public_path__ + "static/media/pl_logo.6ee7b703fd85154da8ff030eacc7f0e7.svg";
export { ForwardRef as ReactComponent };